module.exports = __webpack_public_path__ + "static/middle_road-6d92919c7a897fd7ffa38ee06126d85f.jpg";